// src/pages/income/env/disinfection/incomeEnvDisinfectionDraftConfig.js
// ✅ 수입데이터+수입기안 통합 작성 [3단계] — 환경/소독 사업의 config.
// 종류는 income.IncomeDraft(category="환경/소독") 실사용(496건) 근거: 전부 "소독방역"
// 단일값이라 유일한 전용 종류로 둠. DocumentTypeSelector.jsx의 기존 DETAIL_OPTIONS
// (대금청구/기성계/완수계/준공계 4종)는 실사용과 무관해 채택하지 않음.
//
// ✅ "소독방역" 선택 시 붙임 행 "소독(방역) 청구서 1부"를 기본으로 채운다 — 실제 PDF
// 파일 자동 첨부(DraftAttachment)는 서버(income/views_api.py combined_create의
// post_create 훅, disinfection_invoice 시그널이 만들어둔 청구서를 연결)가 담당하고,
// 이 붙임 행은 그 사실을 문서 본문에 텍스트로 남기는 용도(일반 붙임처럼 수정/삭제 가능).
import { makeIncomeDraftConfig } from "../../_shared/incomeDraftConfig";

const CATEGORIES = [
  { value: "소독방역", label: "소독방역" },
];

const incomeEnvDisinfectionDraftConfig = makeIncomeDraftConfig({
  namespace: "income-env-disinfection-draft",
  category: "환경/소독",
  businessLabel: "환경/소독",
  tabTitle: "소독",
  // ✅ 구버전(draft_document/DraftDocumentNew.jsx) 대금청구 제목 스펙 재현 —
  // "{거래처} 소독방역 {N}월분 대금청구 건" 자동 조립(2026-08-03 버그 신고 대응).
  useClaimTitleTemplate: true,
  // ✅ (구) 페이지가 실제로 쓰는 IncomeDraft.draft_no 접두어와 동일(실측:
  // income/views_api.py IncomeDraftViewSet.create()의 "금천일자리(주)환경/소독-").
  draftNoPrefix: "금천일자리(주)환경/소독",
  dataApiBase: "/income-drafts/",
  combinedCreateApi: "/income-drafts/draft/",
  newRoutePath: "/income/env/disinfection/draft/new",
  listRoutePath: "/income/env/disinfection/draft/list",
  previewRoutePath: "/income/env/disinfection/draft/preview",
  categories: CATEGORIES,
  // ✅ income.models.Partner(간이 거래처 모델) — 경영팀/환경종합과 동일.
  partnerApiBase: "/partners/",
  defaultAttachmentsByCategory: {
    "소독방역": [{ name: "소독(방역) 청구서", count: 1 }],
  },
});

export default incomeEnvDisinfectionDraftConfig;
